
import { Component, Vue, Watch } from 'vue-property-decorator'
import ToggleSwitch from '@/components/ToggleSwitch.vue'

@Component({
  components: {
    ToggleSwitch
  }
})
export default class PronosticoLocalControl extends Vue {
  get isSubmenuSelected () {
    return this.$route.path === '/pronostico-local'
  }
}
